import React from 'react';

import Layout from 'layouts/Layout';
import DeliveryPlanning from './DeliveryPlanning';

const DeliveryPlanningLayout = ({ match }) => <Layout component={DeliveryPlanning} match={match} />;

export default DeliveryPlanningLayout;
